module.exports = __webpack_public_path__ + "static/media/approve-ck.2e3c6770.png";